import React, {Component} from 'react'
import { connect } from 'react-redux'

// import styles
import './MultiStart.scss'

// Actions
import { getEmployees } from '../../../actions/employees'
import { getOrdersInStep, stopOrder } from '../../../actions/orders'

// import components
import Modal from '../../components/Modal'

import { ModalIcons } from '../../elements/icons'

// Utils
import { translation } from '../../../utils/helpers'

class MultiStartModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      selectedOrderIds: [],
      selectedUserIds: [],
      startOrderIds: [],
      startUserIds: [],
      showBtns: false
    }
    this.onChangeUsers = this.onChangeUsers.bind(this)
    this.UserCheckbox = this.UserCheckbox.bind(this)
    this.OrderCheckbox = this.OrderCheckbox.bind(this)
    this.onChangeOrders = this.onChangeOrders.bind(this)
    this.modalTitle = this.modalTitle.bind(this)
    this.click = this.click.bind(this)
    this.Pause = this.Pause.bind(this)
    this.Complete = this.Complete.bind(this)
  }

  componentDidMount () {
    this.props.getOrdersInStep(this.props.step).then((res) => {
      this.setState({
        selectedOrderIds: res.data.OrderIds,
        selectedUserIds: res.data.UserIds,
        startOrderIds: res.data.OrderIds,
        startUserIds: res.data.UserIds,
        showBtns: res.data.OrderIds.length > 0
      }, () => {
        console.log(this.state.selectedOrderIds, this.state.selectedUserIds)
      })
    })
  }

  modalTitle (item) {
    let title = ''

    // Model
    if (item.Model) {
      title += item.Model
    }

    // RegNumber
    if (item.RegNumber) {
      if (item.Model) {
        title += ', '
      }
      title += item.RegNumber
    }

    // Title empty
    if (title === '') {
      title += item.Id || item.OrderId
    }

    return title
  }

  onChangeUsers (e) {
    if (e.target.id === 'allUsers') {
      if (e.target.checked === true) {
        this.setState({
          selectedUserIds: [
            ...this.props.employees.map(function (el) { return Number(el.UserId) })
          ]
        })
      } else if (e.target.checked === false) {
        this.setState({
          selectedUserIds: []
        })
      }
    } else if (e.target.checked === true) {
      this.state.selectedUserIds.push(Number(e.target.id))
      this.setState({
        selectedUserIds: [
          ...this.state.selectedUserIds
        ]
      })
    } else if (e.target.checked === false) {
      var arrayEm = this.state.selectedUserIds
      this.state.selectedUserIds = arrayEm.filter(el => el !== Number(e.target.id))
      this.setState({
        selectedUserIds: [
          ...this.state.selectedUserIds
        ]
      })
    }
  }

  UserCheckbox () {
    const employeesList = (val, key) => {
      let checked = this.state.selectedUserIds.includes(Number(val.UserId))
      return (
        <div className='checkbox__custom control__field' key={key}>
          <input type='checkbox' id={val.UserId} value={val.UserId} name={key} checked={checked} onChange={this.onChangeUsers} />
          <label htmlFor={val.UserId} className='inputCheck'>{val.Name}</label>
        </div>
      )
    }
    return (
      <div className='col floatLeft'>
        <div className='white__box'>
          <div className='title'>
            {translation('10')}
          </div>
          <div className='checklist'>
            <div className='checkbox__custom control__field'>
              <input type='checkbox' id='allUsers' checked={this.props.employees.filter(e => !this.state.selectedUserIds.includes(Number(e.UserId))).length === 0} onChange={this.onChangeUsers} />
              <label htmlFor='allUsers' className='inputCheck'>{translation('531')}</label>
            </div>
            <div>
              {this.props.employees.map(employeesList)}
            </div>
          </div>
        </div>
      </div>
    )
  }

// orders
  onChangeOrders (e) {
    if (e.target.id === 'allOrders') {
      if (e.target.checked === true) {
        this.setState({
          selectedOrderIds: [
            ...this.props.orders.map(function (el) { return Number(el.Id) })
          ]
        })
      } else if (e.target.checked === false) {
        this.setState({
          selectedOrderIds: []
        })
      }
    } else if (e.target.checked === true) {
      this.state.selectedOrderIds.push(Number(e.target.id))
      this.setState({
        selectedOrderIds: [
          ...this.state.selectedOrderIds
        ]
      })
    } else if (e.target.checked === false) {
      var arrayEm = this.state.selectedOrderIds
      this.state.selectedOrderIds = arrayEm.filter(el => el !== Number(e.target.id))
      this.setState({
        selectedOrderIds: [
          ...this.state.selectedOrderIds
        ]
      })
    }
  }

  OrderCheckbox () {
    const orderList = (val, key) => {
      let checked = this.state.selectedOrderIds.includes(Number(val.Id))
      return (
        <div className='checkbox__custom control__field' key={key}>
          <input type='checkbox' id={val.Id} value={val.Id} name={key} checked={checked} onChange={this.onChangeOrders} />
          <label htmlFor={val.Id} className='inputCheck'>{this.modalTitle(val)}</label>
        </div>
      )
    }
    return (
      <div className='col floatRight'>
        <div className='white__box'>
          <div className='title'>
            {translation('720')}
          </div>
          <div className='checklist'>
            <div className='checkbox__custom control__field'>
              <input type='checkbox' id='allOrders' checked={this.props.orders.filter(e => !this.state.selectedOrderIds.includes(Number(e.Id))).length === 0} onChange={this.onChangeOrders} />
              <label htmlFor='allOrders' className='inputCheck'>{translation('531')}</label>
            </div>
            <div>
              {this.props.orders.map(orderList)}
            </div>
          </div>
        </div>
      </div>
    )
  }

  click () {
    console.log('orders', this.state.selectedOrderIds)
    this.props.start(this.state.selectedOrderIds, this.state.selectedUserIds)
  }

  Pause () {
    let data = {
      OrderId: this.state.startOrderIds[0],
      UserId: 0,
      StopAll: true
    }

    this.props.stopOrder(data).then((res) => {
      this.setState({
        selectedOrderIds: [],
        selectedUserIds: [],
        startOrderIds: [],
        startUserIds: []
      })
      // window.toastr.success(translation('12340'), translation('13424'))
      this.props.onClose()
    }, () => {
      window.toastr.error(translation('12342'), translation('216'))
    })
  }

  Complete (all) {
    let OrderIds = []
    this.props.orders.forEach((item) => {
      let val = item.Id
      OrderIds.push(val)
    })

    let data = {
      OrderIds: all === true ? OrderIds : this.state.startOrderIds,
      UserId: 0,
      StepFrom: this.props.step,
      StepTo: this.props.step + 1,
      Comment: '',
      FilterSettings: {},
      MoveAll: true
    }

    this.props.move(data)
    this.props.onClose()
  }

  renderView () {
    return (
      <div>
        <div className='top'>
          {this.state.showBtns && (
            <div>
              <button className='button full primary' onClick={this.Pause}>
                {translation('12344')}
              </button>
              <button className='button full primary' onClick={this.Complete.bind(this, false)}>
                {translation('12345')}
              </button>
            </div>
          )}
          <button className='button full primary' onClick={this.Complete.bind(this, true)}>
            {translation('12346')}
          </button>
        </div>

        {this.UserCheckbox()}
        {this.OrderCheckbox()}
        <button className='button full primary' disabled={this.state.selectedUserIds.length === 0 || this.state.selectedOrderIds.length === 0} onClick={this.click}>
          {translation('956')}
        </button>
      </div>
    )
  }

  render () {
    return (
      <div className='MultiStart__modal'>
        <Modal {...this.props}
          header={translation('2317')}
          overflowHidden={this.state.overflowHidden}
          onClose={this.props.onClose}
          icon={ModalIcons.Shared_Screen}>
          {this.renderView()}
        </Modal>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    employees: state.common.employees.filter(x => x.Active)
  }
}

export default connect(mapStateToProps, {
  getEmployees,
  getOrdersInStep,
  stopOrder
})(MultiStartModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/MultiStart/index.js